import DashboardConfig from './dashboard';
import DropoffsConfig from './dropoffs';
import PickupsConfig from './pickups';
import SchedulingConfig2 from './scheduling2';
import LabConfig from './lab';
import RouteSessionsConfig from './route-sessions';
import DeliveryDocumentsConfig from './delivery-documents';

export default [...DashboardConfig, ...DropoffsConfig, ...PickupsConfig, ...SchedulingConfig2, ...LabConfig, ...RouteSessionsConfig, ...DeliveryDocumentsConfig];
